import { render, staticRenderFns } from "./Cobranzas.vue?vue&type=template&id=34b6c246&scoped=true&"
import script from "./Cobranzas.vue?vue&type=script&lang=js&"
export * from "./Cobranzas.vue?vue&type=script&lang=js&"
import style0 from "./Cobranzas.vue?vue&type=style&index=0&id=34b6c246&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b6c246",
  null
  
)

export default component.exports